import type { WsClientEnvironment } from '@xdocs/ws-protocol';

/**
 * Real browser wiring for the three E20 §5.10-1 reconnect triggers beyond a
 * raw socket drop: `online`, `offline`, and `visibilitychange`→visible.
 * `@xdocs/ws-protocol` never touches `window`/`document` itself (no `dom`
 * lib, §3 — it also ships into Node/tests) — this is `apps/web`'s binding.
 */
export function createBrowserWsEnvironment(): WsClientEnvironment {
  return {
    isOnline(): boolean {
      return typeof navigator === 'undefined' || navigator.onLine !== false;
    },
    onOnline(cb: () => void): () => void {
      window.addEventListener('online', cb);
      return () => window.removeEventListener('online', cb);
    },
    onOffline(cb: () => void): () => void {
      window.addEventListener('offline', cb);
      return () => window.removeEventListener('offline', cb);
    },
    onVisible(cb: () => void): () => void {
      function handler(): void {
        if (document.visibilityState === 'visible') cb();
      }
      document.addEventListener('visibilitychange', handler);
      return () => document.removeEventListener('visibilitychange', handler);
    },
  };
}
